import { Directive, Injectable } from '@angular/core';
import { sendTransaction, waitForTransactionReceipt, getConnectors, getAccount, connect } from '@wagmi/core';
import { ToastrService } from 'ngx-toastr';
import { AppkitService } from 'src/app/core/services/appkit.service';
import { wagmi_config } from 'src/app/core/wagmi/config';
import { SwProcessingService } from 'src/app/shared/services/sw-processing.service';

export interface ITransactionLifecycleCallbacks {
    onAwaitingWallet?: () => void;
    onTransactionSent?: (hash: string) => void;
    onTransactionConfirmed?: (receipt: any) => void;
    onTransactionFailed?: (error: any) => void;
    suppressDefaultErrorToast?: boolean;
}

@Directive({
    selector: '[appManageTransactions]',
    standalone: false
})
@Injectable({ providedIn: 'root' })
export class ManageTransactionsDirective {

    constructor(
        private toastr: ToastrService,
        private appkitService: AppkitService,
        private swProcessingService: SwProcessingService
    ) { }

    public makeTransactions(params: any, callbacks?: ITransactionLifecycleCallbacks) {
        console.log('contract transaction params', params);
        // Marks the transaction as running so a new-build update never reloads the page
        // mid-transaction; released however the transaction ends (see below).
        this.swProcessingService.start();
        const transaction = new Promise(async (resolve, reject) => {
            callbacks?.onAwaitingWallet?.();

            await sendTransaction(this.appkitService.adapter.wagmiConfig, params)
                .then(async (hash: any) => {
                    callbacks?.onTransactionSent?.(hash);

                    await waitForTransactionReceipt(this.appkitService.adapter.wagmiConfig, { hash })
                        .then((response: any) => {
                            callbacks?.onTransactionConfirmed?.(response);
                            resolve({ status: true, data: response });
                        }).catch((error: any) => {
                            console.log("error", error)
                            callbacks?.onTransactionFailed?.(error);
                            reject({ status: false, data: error?.error || error });
                        });
                }).catch((error: any) => {
                    console.log("error log", error);
                    callbacks?.onTransactionFailed?.(error);
                    reject({ status: false, data: error?.error || error });

                    if (!callbacks?.suppressDefaultErrorToast) {
                        if ((error?.toString())?.includes('User rejected the request') || (error?.data?.toString())?.includes('User rejected the request')) {
                            this.toastr.error("User declined the transaction.");
                        }
                        else {
                            this.toastr.error("Something went to wrong");
                        }
                    }
                })
        });
        transaction.then(() => this.swProcessingService.stop(), () => this.swProcessingService.stop());
        return transaction;

    }
}
